<template>
  <section class="apply-step apply-step2">
    <template>
      <!--todo 招行保证金-->
      <!--<newApplyHeader :currentStep="appChannel==='zhaohang'?3:2"></newApplyHeader>-->
      <newApplyHeader currentStep="2"></newApplyHeader>
      <div class="upload-title">
        <span><i class="iconfont etc-icon-01"></i>上传身份证</span>
        <div class="line"></div>
        <span color-primary><i class="iconfont etc-icon-02"></i>上传行驶证</span>
      </div>
    </template>
    <div class="apply-content page-content" :class="{'has-form': showForm, 'more-tip-form': reqErrCode === -2005}">
      <!--<notify notifyText="新能源车暂不支持申办" :initShow="currentIssuer.id === ETC.ISSUER_IDS.gz"></notify>-->
      <div class="apply-wrap">
        <div class="title-wrap">
          <p class="title">
            <span>请上传车辆资料</span>
            <span class="more-wrap" color-primary @click="m_customService">了解更多<i class="iconfont etc-icon-qa"></i></span>
          </p>
        </div>
        <section class="upload-row">
          <photo-upload :photo="vehicle_front" type="license" @uploadEnd="uploadEnd('vehicle_front', $event)"></photo-upload>
          <photo-upload :photo="vehicle_back" type="license" @uploadEnd="uploadEnd('vehicle_back', $event)"></photo-upload>
        </section>
        <!--<section class="upload-row">-->
          <!--<photo-upload :photo="vehicle_car" @uploadEnd="uploadEnd('vehicle_car', $event)"></photo-upload>-->
        <!--</section>-->
      </div>
    </div>
    <section class="apply-bottom">
      <div class="apply-form" :class="{'more-tip': reqErrCode === -2005}" v-show="showForm">
        <p class="form-title">请核对证件信息</p>
        <ul class="form-list">
          <li class="form-item">
            <label>车主姓名</label>
            <input type="text"
                   maxlength="20"
                   placeholder="请输入车主姓名"
                   @change="formChange('owner')"
                   v-model="formData.owner">
          </li>
          <li class="form-item">
            <label>车牌号码</label>
            <div class="value plate-no input" :class="[formData.plate_no?'':'gray']" @click="showPlatePopup">
              <!--<span class="value plate-no input"-->
              <!--@click="showPlatePopup"-->
              <!--:class="[plateColorClass[PLATE_COLORS.indexOf(formData.plate_color)], formData.plate_no?'':'gray']"-->
              <!--&gt;</span>-->
              {{formData.plate_no || '请输入车牌号'}}
            </div>
          </li>
          <!--<li class="form-item">-->
            <!--<label>车牌号码</label>-->
            <!--<div class="value-two">-->
              <!--<span class="value plate-no input"-->
                     <!--@click="showPlatePopup"-->
                     <!--:class="[plateColorClass[PLATE_COLORS.indexOf(formData.plate_color)], formData.plate_no?'':'gray']"-->
                   <!--&gt;{{formData.plate_no || '请输入车牌号'}}</span>-->
              <!--<button class="value" :class="{'gray': !formData.plate_color}" @click="choosePicker('plate_color')">-->
                <!--<span>{{formData.plate_color || '车牌颜色'}}</span><i class="iconfont etc-icon-arrow-down"></i>-->
              <!--</button>-->
            <!--</div>-->
          <!--</li>-->
          <li class="form-item">
            <label>核定载人数</label>
            <button class="value" :class="{'gray': !formData.passengers}" @click="choosePicker('passengers')">
              <span>{{formData.passengers || '请选择核定载人数'}}</span><i class="iconfont etc-icon-arrow-down"></i>
            </button>
          </li>
        </ul>
        <div class="form-err-tip" color-red-tip v-show="(formErrMsg || reqErrMsg || reqErrCode === -2005) && showForm">
          <i class="iconfont etc-icon-warn"></i>
          <p class="err-note" v-if="reqErrCode === -2005">
            行驶证所有人与车主不一致，请核对信息后重填信息或 <span class="link" @click="goStep1">重拍身份证</span> 、行驶证
          </p>
          <span class="err-note" v-else>
          <!--展示三种提示-->
          {{formErrMsg || reqErrMsg}}
        </span>
        </div>
      </div>
      <button cool-btn :disabled="formErrMsg || !allPhotoUpload" @click="apply">下一步</button>
    </section>
    <picker ref="picker" @confirmPicker="confirmPicker($event)"></picker>
    <modal ref="modal" @modalHide="modalHide">
      <div slot="content" class="plate-no-modal" v-if="modalType==='plate'">
        <div class="title">
          <span class="label">输入要办理ETC的车辆车牌号</span>
        </div>
        <div class="input-box">
            <span v-for="(v, i) in plateNos"
                  :class="{'point': i===2, 'eight': i===8, 'focus': (focusIndex===i && i!==2)}"
                  :key="i"
                  @click="tapPlateInput(i)">{{v}}</span>
        </div>
        <plateNoBoard @keyBoardChange="keyBoardChangeEvent($event)" v-model="focusIndex"></plateNoBoard>
      </div>
      <div slot="content" class="diff-plate-modal" v-if="modalType==='diffPlate'">
        <div class="title">
          车牌号不一致
        </div>
        <div class="content">
          <p class="tip">您手动输入的车牌号和目前提交的车牌号不一致，请选择保留的车牌号，修改车牌号需重新签约免密支付</p>
          <div class="line" @click="choosePlate(formData.plate_no.replace(' ', ''))">
            <div class="label">
              <p>{{this.formData.plate_no.replace(' ', '')}}</p>
              <p class="sub-tip">手动输入的车牌号</p>
            </div>
            <i class="iconfont etc-icon-check" color-primary v-if="chooseDiffPlate===formData.plate_no.replace(' ', '')"></i>
            <i class="iconfont etc-icon-yuan" v-else></i>
          </div>
          <div class="line" @click="choosePlate(newApplyInfo.plate_no)">
            <div class="label">
              <p>{{this.newApplyInfo.plate_no}}</p>
              <p class="sub-tip">目前提交的的车牌号</p>
            </div>
            <i class="iconfont etc-icon-check" color-primary v-if="chooseDiffPlate===newApplyInfo.plate_no"></i>
            <i class="iconfont etc-icon-yuan" v-else></i>
          </div>
          <div class="line last" @click="choosePlate('')">
            <div class="label">以上都不是</div>
            <i class="iconfont etc-icon-check" color-primary v-if="chooseDiffPlate===''"></i>
            <i class="iconfont etc-icon-yuan" v-else></i>
          </div>
        </div>
        <div class="btn">
          <button bgc-primary @click="apply('diffPlate')">确定</button>
        </div>
      </div>
    </modal>
  </section>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'
import BiMixin from '@/mixins/biMixin'
// components
import PhotoUpload from '@/components/etc.photoUpload'
import Picker from '@/components/cool.picker'
import Modal from '@/components/cool.modal'
import NewApplyHeader from '@/components/etc.newApplyHeader'
import PlateNoBoard from '@/components/etc.plateNoBoard'
// import Notify from '@/components/cool.notification'
// store
import {mapState, mapMutations} from 'vuex'
// config
import APP from '@/config/app.config'
import ETC from '@/config/etc.config'
// api
// import ApplyApi from '@/api/apply.api'
import reconApply from '@/api/reconApply.api'

// import NewApplyApi from '@/api/newApply.api'

// 未上传: 0, 上传中: 1; 识别成功: 2; 识别失败 上传失败: 3; 4:上传成功(OCR繁忙)
const BTN_NOT_ALLOW = [0, 1, 3]// 不展示表单
// const PLATE_COLORS = ['蓝牌', '渐变绿牌', '黄牌', '其他']
const CAR_PASSENGERS = ['1人', '2人', '3人', '4人', '5人', '6人', '7人', '8人', '9人', '>9人']
const FORM_CHECK_FIELD = ['owner', 'plate_no', 'passengers']
// const FORM_CHECK_FIELD = ['owner', 'plate_no', 'plate_color', 'passengers']
const FORM_ERR_MSG = {
  owner: {isNull: '请输入车主姓名', err: '姓名格式不正确，请重填', REG: APP.NAME_REG},
  plate_no: {
    isNull: '请输入车牌号码',
    err: '车牌号码格式不正确，请重填',
    REG: APP.CAR_PLATE_REG
    // connectErr: '车牌长度与车牌颜色不匹配',
    // connectCheck(form) {
    //   if (form.plate_no) {
    //     return (form.plate_no.length === 7 && form.plate_color !== '蓝牌') || (form.plate_no.length === 8 && form.plate_color !== '渐变绿牌')
    //   }
    //   return false
    // }
  },
  // plate_color: {
  //   isNull: '请选择车牌颜色',
  //   connectErr: '车牌长度与车牌颜色不匹配',
  //   connectCheck(form) {
  //     if (form.plate_no) {
  //       return (form.plate_no.length === 7 && form.plate_color !== '蓝牌') || (form.plate_no.length === 8 && form.plate_color !== '渐变绿牌')
  //     }
  //     return false
  //   }
  // },
  passengers: {isNull: '请选择核定载人数', err: '核定载人数不允许超过9', isErr(val) { return val === '>9人' }}
}
let customData = {
  isIOS: '',
  contentH: 0,
  frontNo: '',
  backNo: '',
  pickerIndex: {passengers: 0}
  // pickerIndex: {plate_color: 0, passengers: 0},
}

export default {
  name: 'uploadVehicle',
  mixins: [FunMixin, BiMixin],
  components: {
    PlateNoBoard,
    NewApplyHeader,
    PhotoUpload,
    Picker,
    Modal
    // Notify
  },
  data() {
    return {
      chooseDiffPlate: '',
      modalType: '',
      plateNos: ['', '', ' ', '', '', '', '', '', ''],
      focusIndex: null,
      formData: {
        owner: '',
        plate_no: '',
        // plate_color: '',
        passengers: ''
      },
      ETC,
      // PLATE_COLORS,
      plateColorClass: ['blue', 'green', 'yellow', ''],
      vehicle_front: {type: 'vehicle_front', status: 0},
      vehicle_back: {type: 'vehicle_back', status: 0},
      // vehicle_car: {type: 'vehicle_car', status: 0},
      showForm: false,
      allPhotoUpload: false,
      formErrMsg: '',
      reqErrMsg: '',
      reqErrCode: ''
    }
  },
  computed: {
    ...mapState(
      [
        'currentCard',
        'currentIssuer',
        'currentOrder',
        'newApplyInfo',
        'lastApplyInfo'
      ])
  },
  methods: {
    choosePlate(p) {
      this.chooseDiffPlate = p
      this.$forceUpdate()
    },
    keyBoardChangeEvent(e) {
      if (e.type === 'tapKey') {
        this.plateNos[this.focusIndex] = e.val
        this.formData.plate_no = this.plateNos.join('')
        this.$forceUpdate()
        if (this.focusIndex === 8) return
        this.focusIndex++
        if (this.focusIndex === 2) this.focusIndex++
      } else if (e.type === 'confirmKey') {
        this.focusIndex = null
        this.$refs.modal.$emit('hideModal')
      } else if (e.type === 'deleteKey') {
        this.plateNos[this.focusIndex] = ''
        this.formData.plate_no = this.plateNos.join('')
        this.$forceUpdate()
        if (this.focusIndex === 0) return
        this.focusIndex--
        if (this.focusIndex === 2) this.focusIndex--
      }
    },
    // 选择车牌输入框
    async tapPlateInput(i) {
      await this.m_clickDebounce('tapPlateInput')
      if (i === 2) return
      this.focusIndex = i
    },
    showPlatePopup() {
      !this.plateNos && (this.plateNos = this.formData.plate_no ? this.formData.plate_no.split('') : ['', '', ' ', '', '', '', '', '', ''])
      this.focusIndex = 0
      this.modalType = 'plate'
      this.$refs.modal.$emit('showModal', {contentSlot: true, defaultFooter: false, close: true})
    },
    modalHide() {
      if (this.modalType === 'plate') {
        this.focusIndex = null
        this.checkForm()
      }
      this.modalType = ''
    },
    goStep1() {
      this.$router.back()
    },
    confirmPicker(e) {
      this.formData[e.key] = e.value
      customData.pickerIndex[e.key] = e.index
      this.checkForm()
    },
    choosePicker(key) {
      this.$refs.picker.$emit('showPicker', {
        key: key,
        initIndex: customData.pickerIndex[key],
        data: [
          {
            data: CAR_PASSENGERS
            // data: key === 'plate_color' ? PLATE_COLORS : CAR_PASSENGERS
          }
        ]
      })
    },
    async apply(type) {
      await this.m_clickDebounce('apply2')
      let formData = Object.assign({}, this.formData)
      if (type === 'diffPlate') {
        this.$refs.modal.$emit('hideModal')
        if (!this.chooseDiffPlate) {
          return
        }
        formData.plate_no = this.chooseDiffPlate
      }
      this.checkForm()
      if (this.formErrMsg) return
      // if (formData.plate_color !== '蓝牌' && formData.plate_color !== '渐变绿牌') {
      //   this.m_showConfirm({content: '暂不支持此类车牌的车辆办理'})
      //   return
      // }
      // formData.plate_color = formData.plate_color.replace(/牌/g, '色')
      formData.plate_no = formData.plate_no.replace(/ /g, '')
      // if (this.currentIssuer.id === ETC.ISSUER_IDS.gz && formData.plate_no.length === 8) {
      //   this.m_showConfirm({content: '新能源车暂不支持申办\n黔通预计在2018年年中支持'})
      //   return
      // }
      if (type !== 'diffPlate' && this.newApplyInfo.plate_no !== formData.plate_no) {
        // const surePlateNo = await this.m_showConfirm({
        //   title: '车牌号不一致',
        //   content: '上传车牌：' + formData.plate_no + '\n与支付前填写的车牌不一致，请核实。',
        //   confirmBtn: '更改车牌',
        //   cancelBtn: '确认无误'
        // })
        // if (surePlateNo) return
        this.chooseDiffPlate = formData.plate_no
        this.modalType = 'diffPlate'
        this.$refs.modal.$emit('showModal', {contentSlot: true, defaultFooter: false, close: true})
        return
      }
      formData.draft_sn = this.lastApplyInfo.draft_sn.license
      formData.vehicle_belong = 1

      try {
        this.m_showLoading('信息校验中')
        // await ApplyApi.checkPlateNo({plate_no: formData.plate_no})
        // await ApplyApi.modifyLicense(formData)
        // await ApplyApi.validateLicense()
        reconApply.userUpdateDraftVehicle(formData)
        this.setCurrentOrder({...this.currentOrder, plate_no: formData.plate_no})
        if (this.appChannel === 'zhaohang') {
          const res = await reconApply.orderSubmitReviewOrder({
            draft_sn_id_card: this.lastApplyInfo.draft_sn.idCard,
            draft_sn_vehicle: this.lastApplyInfo.draft_sn.license
          })
          this.setCurrentOrder({status: 11})
          if (res.review_order.order_sn) {
            this.reqErrMsg = ''
            this.setUserApplyStep(5)
            localStorage.setItem(ETC.LOCAL_STORAGE_KEY.HOME_RELOAD, 'yes')
            this.m_backHome()
          }
        } else {
          this.$router.back()
        }
      } catch (e) {
        this.reqErrMsg = e.msg || ''
        this.reqErrCode = e.code || ''
        console.warn('apply2 apply catch', e)
      } finally {
        this.m_loadingClose()
      }
    },
    uploadEnd(type, data) {
      console.log('apply2 uploadEnd', type, data)
      let ocrResult = data.draft
      if (ocrResult) {
        if (type === 'vehicle_front') customData.frontNo = ocrResult.plate_no
        if (type === 'vehicle_back') customData.banckNo = ocrResult.plate_no
      } else {
        ocrResult = {}
        if (type === 'vehicle_front') {
          ocrResult.owner = ''
          // ocrResult.plate_color = ''
        } else if (type === 'vehicle_back') {
          ocrResult.passengers = ''
        }
      }
      this.formData = Object.assign({}, this.formData, ocrResult)
      if (customData.frontNo || customData.banckNo) this.formData.plate_no = (customData.frontNo || customData.banckNo || '').toUpperCase()
      this.formatForm()
      this.canShowForm()
      this.checkForm()
    },
    canShowForm() {
      let checkP = ['vehicle_front', 'vehicle_back']
      // let checkP = ['vehicle_front', 'vehicle_back', 'vehicle_car']
      let result = true
      for (let i in checkP) {
        if (BTN_NOT_ALLOW.indexOf(this[checkP[i]].status) > -1) {
          result = false
          break
        }
      }
      this.allPhotoUpload = result
      this.showForm = this.showForm || result
    },
    formChange(key) {
      this.formData[key] = this.formData[key].trim()
      this.checkForm()
    },
    plateNoInput() {
      let val = this.formData.plate_no.trim()
      val = val.replace(/ /g, '').replace(/(\S{2})(\S+)/, '$1 $2').toUpperCase()
      this.formData.plate_no = val
      this.checkForm()
    },
    formatForm() {
      if (this.formData.passengers) customData.pickerIndex.passengers = [CAR_PASSENGERS.indexOf(this.formData.passengers)]
      // if (this.formData.plate_color) customData.pickerIndex.plate_color = [PLATE_COLORS.indexOf(this.formData.plate_color)]
      // if (this.formData.plate_color) {
      //   this.formData.plate_color = this.formData.plate_color.replace(/色/g, '牌')
      // } else {
      //   if (this.formData.plate_no) {
      //     let plateNo = this.formData.plate_no.replace(/ /g, '')
      //     if (plateNo.length === 7) {
      //       this.formData.plate_color = '蓝牌'
      //     } else if (plateNo.length === 8) {
      //       this.formData.plate_color = '渐变绿牌'
      //     }
      //   }
      // }
      if (this.formData.passengers) {
        const passengers = this.formData.passengers.replace(/[\u4e00-\u9fa5]/g, '')
        if (Number(passengers) > 9) {
          this.formData.passengers = '9人'
        }
      }
      this.formData.plate_no = this.formData.plate_no.replace(/ /g, '').replace(/(\S{2})(\S+)/, '$1 $2')
    },
    checkForm() {
      if (!this.showForm) return
      const formData = Object.assign({}, this.formData)
      formData.plate_no = formData.plate_no.replace(/ /g, '')
      let result = true
      let msg = ''
      for (let i in FORM_CHECK_FIELD) {
        let k = FORM_CHECK_FIELD[i]
        if (FORM_ERR_MSG[k].isNull && !formData[k]) { // 需要验证空
          result = false
          msg = FORM_ERR_MSG[k].isNull
          break
        }
        if (FORM_ERR_MSG[k].err) {
          if (FORM_ERR_MSG[k].REG && !FORM_ERR_MSG[k].REG.test(formData[k])) {
            result = false
            msg = FORM_ERR_MSG[k].err
            break
          }
          if (FORM_ERR_MSG[k].isErr && FORM_ERR_MSG[k].isErr(formData[k])) {
            result = false
            msg = FORM_ERR_MSG[k].err
            break
          }
        }
        if (FORM_ERR_MSG[k].connectErr) {
          if (FORM_ERR_MSG[k].connectCheck && FORM_ERR_MSG[k].connectCheck(formData)) {
            result = false
            msg = FORM_ERR_MSG[k].connectErr
            break
          }
        }
      }
      this.formErrMsg = msg
      // console.log('check Form', msg)
      return result
    },
    getLastInfo() {
      reconApply.userGetDraft({
        plate_no: this.currentOrder.plate_no,
        plate_color: this.currentOrder.plate_color + ''
      }).then(res => {
        this.setLastApplyInfo(res)
        if (res && res.vehicle) {
          this.formData = res.vehicle
          let images = res.images
          this.vehicle_front = Object.assign(this.vehicle_front, images.vehicle_front)
          this.vehicle_back = Object.assign(this.vehicle_back, images.vehicle_back)
          // this.vehicle_car = Object.assign(this.vehicle_car, images.vehicle_car)
          this.formatForm()
          this.canShowForm()
          this.checkForm()
        }
      })
    },
    ...mapMutations([
      'setUserApplyStep',
      'setCurrentOrder',
      'setLastApplyInfo'
    ])
  },
  async mounted() {
    try {
      this.m_showLoading()
      await this.getLastInfo()
      this.canShowForm()
    } finally {
      this.m_loadingClose()
    }
  },
  async created() {
    customData.isIOS = await this.m_isIOS()
  }
}
</script>

<style scoped lang="scss">
@import "../../style/etc.apply";
.apply-step2{
  @include routeViewMinH(360px);
  .apply-content{
    &.has-form{
      min-height: calc(100vh - 770px);
    }
    &.more-tip-form{
      min-height: calc(100vh - 790px);
    }
  }
  &.iphoneX .apply-content{
    &.has-form{
      min-height: calc(100vh - 770px - 34px);
    }
    &.more-tip-form{
      min-height: calc(100vh - 790px - 34px);
    }
  }
  .form-item .value-two{
    .plate-no{
      &.blue{
        background-color: #3289F7;
        border-width: 0;
        color: #FFFFFF;
      }
      &.green{
        background-image: linear-gradient(-180deg, #F3F3F3 21%, #11C70F 100%);
        border-width: 0;
      }
      &.yellow{
        background-color:  #F4C12C;
        border-width: 0;
      }
    }
  }
  .zhong-an-tip-modal{
    height: 100vh;
    background-color: #f5f5f5;
    padding-top: 30px;
    .modal-content{
      width: 690px;
      margin: 0 auto;
      background-color: #fff;
      font-size: 30px;
      border-radius: 8px;
      p{
        margin: 0 45px;
        padding: 50px 0;
        text-indent: 2em;
      }
    }
    .btns{
      padding: 70px 45px 0;
      text-align: center;
      font-size: 32px;
      [cool-btn]{
        font-size: 32px;
      }
      .not-agree{
        margin-top: 30px;
        padding: 10px;
        color: #909090;
      }
    }
  }
  .plate-no-modal{
    padding-bottom: 500px;
    padding-top: 68px;
    background-color: #FFFFFF;
    @extend %plate-no;
    .title{
      font-size: 32px;
      padding-bottom: 20px;
    }
  }
  .diff-plate-modal{
    background-color: #fff;
    padding-top: 40px;
    .title{
      text-align: center;
      font-size: 36px;
      font-weight: bold;
    }
    .content{
      padding: 0 40px 80px;
    }
    .tip{
      margin-top: 40px;
      font-size: 26px;
      line-height: 40px;
      padding: 0 0 45px;
      text-align: center;
    }
    .line{
      @extend %flex-space-between;
      height: 127px;
      border-bottom: 1px solid #ddd;
      .label{
        font-size: 30px;
        .sub-tip{
          font-size: 24px;
          color: #999999;
        }
      }
      .iconfont{
        font-size: 40px;
      }
      .etc-icon-yuan{
        color: #999999;
      }
      &.last{
        height: 100px;
      }
    }
    .btn{
      button{
        width: 100%;
        height: 100px;
        line-height: 100px;
        color: #FFFFFF;
        font-size: 36px;
      }
    }
  }
}
</style>
